import { useSearchParams } from 'next/navigation';

import { getOrCreateNewSearchId } from './getOrCreateNewSearchId';
import { useProductsSearchWithFallback } from './useProductsSearchWithFallback';

export function useSearchId() {
  const params = useSearchParams();
  const { data, isStale, isFetching } = useProductsSearchWithFallback(
    params.get('q') || ''
  );
  const inFlightRequestSearchId = getOrCreateNewSearchId();
  const initialPageSearchId = data?.pages[0]?.searchId;

  // If data is stale, and we're refetching, prioritise using the inFlightRequestSearchId
  if (isStale && isFetching) {
    return inFlightRequestSearchId;
  }

  // Else, if data is not stale and is present, use the ID from the 0th page
  // Otherwise, use the inFlightRequestSearchId
  return initialPageSearchId || inFlightRequestSearchId;
}
